import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Slider, FormControl } from 'components';
import styles from './RangePreview.scss';

const RangePreview = ({
    isDisabled,
    onChange,
    minValue,
    maxValue,
    defaultValue,
    ...props
}) => {
    const [value, setValue] = useState(defaultValue);

    const handleChange = (event, newValue) => {
        onChange(newValue);
        setValue(newValue);
    };

    return (
        <FormControl fullWidth>
            <Slider
                {...props}
                className={styles.rangeSlider}
                min={minValue}
                max={maxValue}
                value={value}
                onChange={handleChange}
                disabled={isDisabled}
                valueLabelDisplay='on'
            />
        </FormControl>
    );
};

RangePreview.propTypes = {
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    defaultValue: PropTypes.number
};

RangePreview.defaultProps = {
    isDisabled: false,
    onChange: () => {},
    minValue: 0,
    maxValue: 0,
    defaultValue: 0
};

export default RangePreview;
